import axios from "@/api/config";

const schoolPage = {
  getHomePageListSetting(id, data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getHomePageListSetting`,
      {
        params: data
      }
    );
  },
  getHomePageListByTemplateId(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getHomePageListByTemplateId`,
      {
        params: data
      }
    );
  },
  updateTempCover(data) {
    return axios.put(
      `${process.env.BASE_URL}/dictionary/updateDictionary`,
      data
    );
  },
  menuPageList(data) {
    return axios.post(`${process.env.BASE_URL}/schoolPageMenu/pageList`, data);
  },
  updateAgentTemp(data) {
    return axios.put(`${process.env.BASE_URL}/agentInfo/setTheme`, data);
  },
  menuSwitch(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/pageSchoolMenuSwitch`,
      {
        params: data
      }
    );
  },
  // importData(data) {
  //   return axios.post(`${process.env.BASE_URL}/agentApp/importData`, data);
  // }

  informationPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/informationPageList`,
      data
    );
  },
  getSubjectPList(data) {
    return axios.get(`${process.env.BASE_URL}/schoolPage/getSubjectPList`, {
      params: data
    });
  },
  updateHomeSchoolPage(id, data) {
    // ?templateId=${id}
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/updateHomeSchoolPage`,
      data
    );
  },
  getGoodsListByType(data) {
    return axios.get(`${process.env.BASE_URL}/schoolPage/getGoodsListByType`, {
      params: data
    });
  },
  addAgentCompanyInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/agentCompanyInfo/addAgentCompanyInfo`,
      data
    );
  },
  getAgentCompanyInfo(data) {
    return axios.get(
      `${process.env.BASE_URL}/agentCompanyInfo/getAgentCompanyInfo`,
      {
        params: data
      }
    );
  },
  getGeneralSettingDetail(data) {
    return axios.get(
      `${process.env.BASE_URL}/generalSetting/getGeneralSettingDetail`,
      {
        params: data
      }
    );
  },
  getCardInfoAppAndQrCode(data) {
    return axios.get(
      `${process.env.BASE_URL}/cardInfo/getCardInfoAppAndQrCode`,
      {
        params: data
      }
    );
  },
  addOrUpdateCardInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/cardInfo/addOrUpdateCardInfo`,
      data
    );
  },
  getCardInfo(data) {
    return axios.get(`${process.env.BASE_URL}/cardInfo/getCardInfo`, {
      params: data
    });
  },
  getMiniAppQrCode(data) {
    return axios.get(`${process.env.BASE_URL}/wx/user/getMiniAppQrCode`, {
      params: data
    });
  },
  studentLoginInfoPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/student/recommendStudentList`,
      data
    );
  },
  getSchoolPageMenuList() {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuList`
    );
  },
  updateHomeSchoolPageByTemplateId(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/updateHomeSchoolPageByTemplateId`,
      data
    );
  },
  getCourseCenterGoodsPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/getCourseCenterGoodsPageList`,
      data
    );
  }
};

export default schoolPage;



// WEBPACK FOOTER //
// ./src/api/schoolPage.js